export const PORTRAIT = 'portrait'
export const LANDSCAPE = 'landscape'
export function getUUID () { // UUID v4 generator in JavaScript (RFC4122 compliant)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0; var v = c == 'x' ? r : (r & 3 | 8)
    return v.toString(16)
  })
}

export function getOrientation () {
  if (window.matchMedia('(orientation: portrait)').matches) {
    return PORTRAIT
  }
  if (window.matchMedia('(orientation: landscape)').matches) {
    return LANDSCAPE
  }
}
